import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import PaginationAdvanced from "../../components/PaginationAdvanced";
import { CSSTransitionGroup } from 'react-transition-group';
import moment from "moment";
import Search from "../Search";
import { toastr } from "react-redux-toastr";
import * as Constants from '../../constants';
import { Modal } from "react-bootstrap";

import Index from "../Index";
import { fetchAllEmailBroadcasts, cancelEmailBroadcast } from "../../actions/index";

export class AdminEmailBroadcastsIndex extends Index {
  static propTypes = {
    fetchAllEmailBroadcasts: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    emailBroadcasts: PropTypes.object,
    cancelEmailBroadcast: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
  }

  openFailureStatsModal(emailBroadcastId) {
    this.setState({ showFailureStatsModal: emailBroadcastId });
  }

  openFailureStats(emailBroadcastId, e) {
    e.preventDefault();
    this.openFailureStatsModal(emailBroadcastId);
  }

  closeFailureStatsModal() {
    this.setState({ showFailureStatsModal: false });
  }

  showFailureStatsModal(emailBroadcastId) {
    if (this.state.showFailureStatsModal == emailBroadcastId) {
      return true;
    } else {
      return false;
    }
  }

  fetchData() {
    let newQueries = {
        page: this.state.page || 1,
        per_page: this.state.per_page || "",
        search: this.state.search || "",
        category: this.state.category || "",
        sort: this.state.sort || "",
        direction: this.state.direction || ""
      };
    this.props.fetchAllEmailBroadcasts(
      this.serialize(newQueries)
    );
    this.props.history.push(`/admin/email_broadcasts${this.serialize(newQueries)}`);
  }

  cancelLink(emailBroadcast) {
    if (
      emailBroadcast.cancelled_at != null ||
      emailBroadcast.unhandled_count == 0
    ) {
      return "";
    } else {
      return (
        <button
          className="btn btn-xs btn-danger"
          onClick={this.handleCancelEmailBroadcast.bind(this)}
          data-id={emailBroadcast.id}
        >
          Cancel
        </button>
      );
    }
  }

  status(emailBroadcast) {
    if (emailBroadcast.cancelled_at != null) {
      return <span className="label label-default">Cancelled</span>;
    } else if (emailBroadcast.unhandled_count == 0) {
      return <span className="label label-success">Sent</span>;
    } else if (emailBroadcast.pause_delivery_until != null) {
      return <span className="label label-danger">Throttled</span>;
    } else if (emailBroadcast.delivery_window_starts_at != null) {
      return (
        <span className="label label-default">
          Scheduled for{" "}
          {moment(emailBroadcast.delivery_window_starts_at).format(
            "MM/DD/YYYY h:mm:ss A"
          )}
        </span>
      );
    } else {
      return <span className="label label-info">Sending</span>;
    }
  }

  handleCancelEmailBroadcast(e) {
    let eblastId = e.target.dataset.id;
    if (
      confirm(
        "Are you sure you want to cancel this eBlast?\nThis cannot be undone."
      )
    ) {
      this.props
        .cancelEmailBroadcast(eblastId)
        .then(() => {
          toastr.success("EBlast cancelled!");
          this.fetchData();
        });
    }
  }

  dropped_count(emailBroadcast) {
    return emailBroadcast.dropped_count;
  }

  renderEmailBroadcasts() {
    if (!this.props.emailBroadcasts.data) {
      return (
        <tr>
          <td colSpan={17}>
            <div className="vertical-center">
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              >
                <i className="fa fa-refresh fa-4x fa-spin" />
              </CSSTransitionGroup>
            </div>
          </td>
        </tr>
      );
    } else if (this.props.emailBroadcasts.data.length == 0) {
      return (
        <tr>
          <td colSpan={17}>
            <div className="well well-lg text-center">
              You have no eBlasts.&nbsp;
            </div>
          </td>
        </tr>
      );
    }

    return this.props.emailBroadcasts.data.map(emailBroadcast => {
      let search = null;
      if (emailBroadcast.search) {
        search = JSON.parse(emailBroadcast.search);
      }
      return (
        <tr key={emailBroadcast.id}>
          <td>
            <Link
              to={`/eblasts/${ emailBroadcast.id }/emails?${Constants.DEFAULT_PAGINATION}`}
            >
              <strong>
                {moment(emailBroadcast.created_at).format(
                  "MM/DD/YYYY h:mm:ss A"
                )}
              </strong>
            </Link>
          </td>
          <td>
            <Link to={`/eblasts/${ emailBroadcast.id }/emails?${Constants.DEFAULT_PAGINATION}`} >
              <strong>
                { emailBroadcast.completed_at ? moment(emailBroadcast.completed_at).format( "MM/DD/YYYY h:mm:ss A") : '' }
              </strong>
            </Link>
          </td>
          <td>{this.status(emailBroadcast)}</td>
          <td>
            <Link to={`/campaigns`} >
              {emailBroadcast.company_name}
            </Link>
          </td>
          <td>
            <Link to={`/campaigns`} > {emailBroadcast.company_site_uuid} </Link>
          </td>
          <td>{emailBroadcast.name}</td>
          <td>{emailBroadcast.subject}</td>
          <td className="text-right">{emailBroadcast.selected_count ? emailBroadcast.selected_count.toLocaleString() : ''}</td>
          <td className="text-right">
            {emailBroadcast.delivered_count > emailBroadcast.sent_emails_count
              ? emailBroadcast.delivered_count.toLocaleString()
              : emailBroadcast.sent_emails_count.toLocaleString()}
          </td>
          <td className="text-right">{emailBroadcast.delivered_count ? emailBroadcast.delivered_count.toLocaleString() : ''}</td>
          <td className="text-right">{emailBroadcast.opened_count ? emailBroadcast.opened_count.toLocaleString() : ''}</td>
          <td className="text-right">{emailBroadcast.clicked_count ? emailBroadcast.clicked_count.toLocaleString() : ''}</td>
          <td className="text-right">{emailBroadcast.unsubscribed_count ? emailBroadcast.unsubscribed_count.toLocaleString() : ''}</td>
          <td className="text-right">{emailBroadcast.complained_count ? emailBroadcast.complained_count.toLocaleString() : ''}</td>
          <td className="text-right">{emailBroadcast.bounced_count ? emailBroadcast.bounced_count.toLocaleString() : ''}</td>
          <td className="text-right">{this.dropped_count(emailBroadcast).toLocaleString()}</td>
          <td className="text-left">
            <Link
              to={`/eblasts/${ emailBroadcast.id }/emails?${Constants.DEFAULT_PAGINATION}`}
              className="btn btn-xs btn-default eblast_emails"
            >
              Details
            </Link>
          </td>
          <td>{this.cancelLink(emailBroadcast)}</td>
          <td className="text-right">
            <button
              className="btn btn-sm btn-default template_btn_more_info"
              data-emailBroadcast-id={emailBroadcast.id}
              onClick={this.openFailureStats.bind(this, emailBroadcast.id)}
            >
              View Fail Stats
            </button>
            <Modal
              show={this.showFailureStatsModal(emailBroadcast.id)}
              onHide={this.closeFailureStatsModal.bind(this)}
              backdrop="static"
              keyboard={false}
              autoFocus={true}
              enforceFocus={false}
              key={emailBroadcast.id}
              className="failure_stats_modal"
            >
              <Modal.Header closeButton={true}>
                <Modal.Title id="contained-modal-title-lg">
                  {emailBroadcast.name}: Stats for leads not sent
                </Modal.Title>
              </Modal.Header>
              <Modal.Body className="failure_stats">
                <h4> Stats </h4>
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th className={`text-right `} > Selected </th>
                      <th className={`text-right email_failure_stats`} > OK </th>
                      <th className={`text-right email_failure_stats`} > Not Active </th>
                      <th className={`text-right email_failure_stats`} > Email Blank </th>
                      <th className={`text-right email_failure_stats`} > Bad Email </th>
                      <th className={`text-right email_failure_stats`} > Unsub. </th>
                      <th className={`text-right email_failure_stats`} > Uneng. Too Long </th>
                      <th className={`text-right email_failure_stats`} > Uneng. Too Many </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-right">{emailBroadcast.selected_count ? emailBroadcast.selected_count.toLocaleString() : ''}</td>
                      <td className="text-right">{emailBroadcast.failure_stats && emailBroadcast.failure_stats.ok ? emailBroadcast.failure_stats.ok.toLocaleString() : ''}</td>
                      <td className="text-right">{emailBroadcast.failure_stats && emailBroadcast.failure_stats.not_active  ? emailBroadcast.failure_stats.not_active.toLocaleString() : ''}</td>
                      <td className="text-right">{emailBroadcast.failure_stats && emailBroadcast.failure_stats.email_blank ? emailBroadcast.failure_stats.email_blank.toLocaleString() : ''}</td>
                      <td className="text-right">{emailBroadcast.failure_stats && emailBroadcast.failure_stats.bad_email ? emailBroadcast.failure_stats.bad_email.toLocaleString() : ''}</td>
                      <td className="text-right">{emailBroadcast.failure_stats && emailBroadcast.failure_stats.unsubscribed ? emailBroadcast.failure_stats.unsubscribed.toLocaleString() : ''}</td>
                      <td className="text-right">{emailBroadcast.failure_stats && emailBroadcast.failure_stats.unengaged_too_long ? emailBroadcast.failure_stats.unengaged_too_long.toLocaleString() : ''}</td>
                      <td className="text-right">{emailBroadcast.failure_stats && emailBroadcast.failure_stats.unengaged_too_many ? emailBroadcast.failure_stats.unengaged_too_many.toLocaleString() : ''}</td>
                    </tr>
                  </tbody>
                </table>
                <h4> Search Info </h4>
                <table className="table table-striped">
                  <tbody>
                    <tr>
                      <th className={``} > Apply To </th>
                      <td className="">{emailBroadcast.apply_to}</td>
                    </tr>
                    <tr>
                      <th className={``} > Search Name </th>
                      <td className="">{search ? search.search_name : ""}</td>
                    </tr>
                    <tr>
                      <th className={``} > Search Params </th>
                      <td className="">{search ? JSON.stringify(search, null, '\t') : ""}</td>
                    </tr>
                  </tbody>
                </table>
              </Modal.Body>
            </Modal>
          </td>
        </tr>
      );
    });
  }

  render() {
    let count = 0;
    if (this.props.emailBroadcasts.meta) {
      count = this.props.emailBroadcasts.meta.count;
    }
    return (
      <div className="emailBroadcasts_index">
        <div className="row">
          <h1>
            eBlasts
            <div className="pull-right">
              <Search
                handleSearch={this.handleSearch.bind(this)}
                searchStr={this.state.search}
              />
            </div>
          </h1>
        </div>
        <div className="row">
          <table className="table table-striped">
            <thead>
              <tr>
                <th
                  className={`email_broadcast_date ${this.indicateSorting(
                    "created_at"
                  )}`}
                  data-sort="created_at"
                  onClick={this.handleOrder.bind(this)}
                >
                  Created
                </th>
                <th
                  className={`email_broadcast_date ${this.indicateSorting(
                    "completed_at"
                  )}`}
                  data-sort="completed_at"
                  onClick={this.handleOrder.bind(this)}
                >
                  Completed
                </th>
                <th className={`email_broadcast_status`} data-sort="created_at">
                  Status
                </th>
                <th className={`email_broadcast_company_name`}
                  data-sort="company_name"
                >
                  Company
                </th>
                <th className={`email_broadcast_company_site_uuid`}
                  data-sort="company_site_uuid"
                >
                  Company UUID
                </th>
                <th
                  className={`email_broadcast_name ${this.indicateSorting(
                    "name"
                  )}`}
                  data-sort="name"
                  onClick={this.handleOrder.bind(this)}
                >
                  Name
                </th>
                <th
                  className={`email_broadcast_subject ${this.indicateSorting(
                    "subject"
                  )}`}
                  data-sort="subject"
                  onClick={this.handleOrder.bind(this)}
                >
                  Subject
                </th>
                <th
                  className={`text-right email_stats_queued ${this.indicateSorting(
                    "selected_count"
                  )}`}
                  data-sort="selected_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Selected
                </th>
                <th
                  className={`text-right email_stats_queued ${this.indicateSorting(
                    "sent_emails_count"
                  )}`}
                  data-sort="sent_emails_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Sent
                </th>
                <th
                  className={`text-right email_stats_delivered ${this.indicateSorting(
                    "delivered_count"
                  )}`}
                  data-sort="delivered_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Delivered
                </th>
                <th
                  className={`text-right email_stats_opened ${this.indicateSorting(
                    "opened_count"
                  )}`}
                  data-sort="opened_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Opens
                </th>
                <th
                  className={`text-right email_stats_clicked ${this.indicateSorting(
                    "clicked_count"
                  )}`}
                  data-sort="clicked_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Clicks
                </th>
                <th
                  className={`text-right email_stats_unsubscribed ${this.indicateSorting(
                    "unsubscribed_count"
                  )}`}
                  data-sort="unsubscribed_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Unsubs
                </th>
                <th
                  className={`text-right email_stats_spam_report ${this.indicateSorting(
                    "complained_count"
                  )}`}
                  data-sort="complained_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Spam R.
                </th>
                <th
                  className={`text-right email_stats_bounced ${this.indicateSorting(
                    "bounced_count"
                  )}`}
                  data-sort="bounced_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Bounces
                </th>
                <th
                  className={`text-right email_stats_failed ${this.indicateSorting(
                    "dropped_count"
                  )}`}
                  data-sort="dropped_count"
                  onClick={this.handleOrder.bind(this)}
                >
                  Failures
                </th>
                <th className="text-right" colSpan={2} />
              </tr>
            </thead>
            <tbody>{this.renderEmailBroadcasts()}</tbody>
          </table>
        </div>
        <div className="row text-right">
          <PaginationAdvanced
            handle={this.handlePagination.bind(this)}
            total={count}
            page={this.state.page}
            per_page={this.state.per_page}
          />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { emailBroadcasts: state.emailBroadcasts.all };
}

export default connect(
  mapStateToProps,
  { fetchAllEmailBroadcasts, cancelEmailBroadcast }
)(AdminEmailBroadcastsIndex);
